import axios from "axios";
import { UnitedKingdomFlag, VietNamFlag } from "../components/Icons/HomeHeader";
import i18n from "../i18n";
const { t } = i18n;
export const isValidatorPhone = (phone) => {
  const regex = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
  return phone.match(regex);
};
export const isValidatorEmail = (email) => {
  const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i;
  return !!email.match(email.match(regex));
};

export const isValidatorName = (name) => {
  const regex = /^[\p{L}\s]+$/u;
  return !!name.match(regex);
};

export const isValidateToken = (token) => {
  const regex = /^[0-9]{6}$/;
  return !!token?.match(regex);
};

export const isValidatorUrl = (url) => {
  const regex = /(rtsp):\/\/([^\s@/]+)@([^\s/:]+)(?::([0-9]+))?(\/.*)/;
  const regex1 =
    /^rtsp:\/\/[a-z0-9]+\.[a-z]+\.stream\/\w+\?streamKey=[a-z0-9]+$/i;
  if (url && (url.match(regex) || url.match(regex1))) {
    return true;
  } else {
    return false;
  }
};
export const SizeOfElement = (element) => {
  if (element) {
    let { width, height, top, right, bottom, left } =
      element.getBoundingClientRect();
    let parentHeight = document.body.offsetHeight;
    let parentWidth = document.body.offsetWidth;
    let parentFullHeight = document.body.scrollHeight;
    let parentFullWidth = document.body.scrollWidth;
    let scrollHeight = element.scrollHeight;
    let scrollWidth = element.scrollWidth;

    return {
      width: width,
      height: height,
      elementTop: top,
      elementBottom: parentHeight - bottom,
      elementRight: parentWidth - right,
      elementLeft: left,
      screenHeight: parentHeight,
      screenWidth: parentWidth,
      htmlWidth: parentFullWidth,
      htmlHeight: parentFullHeight,
      scrollHeight: scrollHeight,
      scrollWidth: scrollWidth,
    };
  }
};

export const isValidatePassword = (password) => {
  const regex =
    /^(?=.*[A-Z])(?=.*[a-z])(?=.*[©®™✓•√π÷×§∆£€$¢°@^$!%*#?&()=+_`~\-{}\[\]\\|;:'",<.>\/])[^\s]{6,20}$/;
  return !!password?.match(regex);
};
export const isValidateCompanyCode = (companyCode) => {
  if (companyCode) {
    const regex = /^[A-Z0-9]+$/;
    return !!companyCode?.match(regex);
  }
  else {
    return false
  }
};
export const isValidateConfirm = (oldVar, newVar) => {
  if (oldVar?.length === newVar?.length) {
    return oldVar === newVar;
  }
};
export const formatDate = (date) => {
  const dateA = new Date(date);
  const year = dateA.getFullYear();
  const month = dateA.getMonth() + 1;
  const day = dateA.getDate();
  return (
    year +
    "-" +
    (month <= 9 ? "0" + month : month) +
    "-" +
    (day <= 9 ? "0" + day : day)
  );
};
export const formatDates = (date) => {
  const dateA = new Date(date);
  const year = dateA.getFullYear();
  const month = dateA.getMonth() + 1;
  const day = dateA.getDate();
  return (
    (day <= 9 ? "0" + day : day) +
    "-" +
    (month <= 9 ? "0" + month : month) +
    "-" +
    year
  );
};
export const formatDateYesterday = (date) => {
  const dateA = new Date(date);
  const year = dateA.getFullYear();
  const month = dateA.getMonth() + 1;
  let dateNow = dateA.getDate() - 1;
  const day = dateNow !== 0 ? dateNow : dateNow + 1;
  return (
    year +
    "-" +
    (month <= 9 ? "0" + month : month) +
    "-" +
    (day <= 9 ? "0" + day : day)
  );
};

export const formatDateToTime = (date) => {
  const dateA = new Date(date);
  const year = dateA.getFullYear();
  const month = dateA.getMonth() + 1;
  const day = dateA.getDate();
  const hour = dateA.getHours();
  const minute = dateA.getMinutes();
  const seconds = dateA.getSeconds();
  const dateToTime =
    (day <= 9 ? "0" + day : day) +
    "/" +
    (month <= 9 ? "0" + month : month) +
    "/" +
    year +
    " - " +
    (hour <= 9 ? "0" + hour : hour) +
    ":" +
    (minute <= 9 ? "0" + minute : minute) +
    ":" +
    (seconds <= 9 ? "0" + seconds : seconds);
  return dateToTime;
};
export const formatDateToHour = (date) => {
  const dateA = new Date(date);
  const year = dateA.getFullYear();
  const month = dateA.getMonth() + 1;
  const day = dateA.getDate();
  const hour = dateA.getHours();
  const minute = dateA.getMinutes();
  const seconds = dateA.getSeconds();
  const dateToTime =
    (day <= 9 ? "0" + day : day) +
    "/" +
    (month <= 9 ? "0" + month : month) +
    "/" +
    year +
    " - " +
    (hour <= 9 ? "0" + hour : hour) +
    ":" +
    (minute <= 9 ? "0" + minute : minute);
  return dateToTime;
};
export const isValidateUserName = (data) => {
  const regex = /^[a-z0-9.@]{6,100}$/;
  return !!data?.match(regex);
};
export const format = (date) => {
  const dateA = new Date(date);
  const year = dateA.getFullYear();
  const month =
    dateA.getMonth() + 1 < 10
      ? "0" + (dateA.getMonth() + 1)
      : dateA.getMonth() + 1;
  const day = dateA.getDate() < 10 ? "0" + dateA.getDate() : dateA.getDate();
  return year + "-" + month + "-" + day;
};
export const formatDDMMYY = (date, mon) => {
  const dateA = new Date(date);
  const year = dateA.getFullYear();
  const month =
    dateA.getMonth() + 1 < 10
      ? "0" + (dateA.getMonth() + 1)
      : dateA.getMonth() + 1;
  const day = dateA.getDate() < 10 ? "0" + dateA.getDate() : dateA.getDate();
  const time = (Number(month) + mon - Math.floor(mon / 12) * 12) < 10 ? ("0" + (Number(month) + mon - Math.floor(mon / 12) * 12)) : (Number(month) + mon - Math.floor(mon / 12) * 12)
  return mon ? (day + "/" + time + "/" + (Number(year) + Math.floor(mon / 12))) : (day + "/" + month + "/" + year)
};
export const formatYYMMDD = (date) => {
  const dateA = new Date(date);
  const year = dateA.getFullYear();
  const month =
    dateA.getMonth() + 1 < 10
      ? "0" + (dateA.getMonth() + 1)
      : dateA.getMonth() + 1;
  const day = dateA.getDate() < 10 ? "0" + dateA.getDate() : dateA.getDate();
  return year + "/" + month + "/" + day;
};
export const formatHour = (date) => {
  const dateA = new Date(date);
  const hour =
    dateA.getHours() < 10 ? "0" + dateA.getHours() : dateA.getHours();
  const minute =
    dateA.getMinutes() < 10 ? "0" + dateA.getMinutes() : dateA.getMinutes();
  return hour + ":" + minute;
};
export const checkValidatorSubmit = (regexInput, input = []) => {
  const checkInput =
    input.length > 0
      ? input.every(
        (item) =>
          item?.trim()?.length !== "" || item === undefined || item === null
      )
      : false;
  if (regexInput && checkInput) {
    return true;
  }
  return false;
};

export const formatTimeHHMMSS = (time) => {
  const date = new Date(time);
  const hour = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
  const minute =
    date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
  const second =
    date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
  return hour + ":" + minute + ":" + second;
};
const parseDate = (str) => {
  const [month, day, year] = str.split("-");
  return new Date(year, month - 1, day);
};

const datediff = (first, second) => {
  return Math.round((second - first) / (1000 * 60));
};
const parseMinute = (time) => {
  const [hour, minute] = time.split(":");
  return Number(hour * 60) + Number(minute);
};

export const countTime = (start, end) => {
  if (parseMinute(start?.split(" ")[1]) > parseMinute(end?.split(" ")[1])) {
    return (
      datediff(parseDate(start.split(" ")[0]), parseDate(end.split(" ")[0])) +
      (parseMinute(start.split(" ")[1]) - parseMinute(end.split(" ")[1]))
    );
  } else {
    return (
      datediff(parseDate(start.split(" ")[0]), parseDate(end.split(" ")[0])) -
      (parseMinute(start.split(" ")[1]) - parseMinute(end.split(" ")[1]))
    );
  }
};

export const isValidatorVisaMasterCard = (number) => {
  const regex = /^(?:4[0-9]{12}(?:[0-9]{3})?|5[1-5][0-9]{14})$/;
  return !!number.match(regex);
};

export const getDateEnd = (date, end) => {
  let dateA = new Date(date);
  let year = dateA.getFullYear();
  let month = dateA.getMonth() + 1;
  let day = dateA.getDate();
  let monthEnd = month + end;
  if (monthEnd > 12) {
    month = monthEnd - 12;
    year = year + 1;
  } else {
    month = monthEnd;
  }
  return (
    year +
    "-" +
    (month < 10 ? "0" + month : month) +
    "-" +
    (day < 10 ? "0" + day : day)
  );
};

export const CheckUserAgent = (agent) => {
  if (agent.indexOf("Chrome") > -1) {
    return "Chrome";
  } else if (agent.indexOf("Firefox") > -1) {
    return "Firefox";
  } else if (agent.indexOf("Safari") > -1) {
    return "Safari";
  } else {
    return "Mobile App";
  }
};

export const CheckTimeRecord = (start, end) => {
  const now = new Date().toTimeString();
  const hoursNow = now.slice(0, 5);
  if (!start || !end) {
    return false;
  } else if (start < end && start > hoursNow) {
    return true;
  }
};

export const validatorDataIsNumber = (data) => {
  const regexNumber = /^[0-9]/;
  if (data.match(regexNumber)) {
    return true;
  } else {
    return false;
  }
};

export const validatorInfoWareHouse = (infoWareHouse) => {
  const check =
    infoWareHouse.province_code &&
    infoWareHouse.district_code &&
    infoWareHouse.commune_code &&
    infoWareHouse.commune_code &&
    infoWareHouse.address_detail.trim().length > 0 &&
    infoWareHouse.subject_name.trim().length > 0 &&
    infoWareHouse.longitude.trim().length > 0 &&
    infoWareHouse.latitude.trim().length > 0;
  return check;
};

export const array_move = (arr, old_index, new_index) => {
  if (new_index >= arr.length) {
    var k = new_index - arr.length + 1;
    while (k--) {
      arr.push(undefined);
    }
  }
  arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
  return arr;
};

export const emptyCache = () => {
  if ("caches" in window) {
    caches.keys().then((names) => {
      // Delete all the cache files
      names.forEach((name) => {
        caches.delete(name);
      });
    });
    // Makes sure the page reloads. Changes are only visible after you refresh.
    // window.location.reload(true);
  }
};

export const sorterArray = (data, name) => {
  const newData = data.map((item) => {
    if (item[name] && item[name].length > 0) {
      return item;
    } else if (typeof item[name] === "number" && item[name] !== 0) {
      return item;
    } else if (typeof item[name] === "number" && item[name] === 0) {
      return {
        ...item,
        [name]: 0.1,
      };
    } else {
      return {
        ...item,
        [name]: "z",
      };
    }
  });
  const sorter2 = (sortBy) => (a, b) => {
    const prev = a[sortBy];
    const next = b[sortBy];
    if (typeof prev !== "number") {
      let oldPosition = [prev, next];
      let newPosition = oldPosition.sort((a, b) =>
        a.localeCompare(b, "vi", { ignorePunctuation: true })
      );
      let oldIndex = oldPosition.findIndex((item) => item === prev);
      let newIndex = newPosition.findIndex((item) => item === next);
      if (prev && next && oldIndex === newIndex) {
        return 1;
      } else {
        return -1;
      }
    } else {
      if (prev && next) {
        return prev - next;
      }
    }
  };
  const fillData = newData.sort(sorter2(name));
  const afterData = fillData.map((item) => {
    if (item[name] === "z") {
      return {
        ...item,
        [name]: "",
      };
    } else if (item[name] === 0.1) {
      return {
        ...item,
        [name]: 0,
      };
    } else {
      return item;
    }
  });
  return afterData;
};

export const sorterArrayChildIsManyObj = (data, nameParent, nameChild) => {
  const newData = data.map((item) => {
    if (
      item[nameParent][nameChild] &&
      typeof item[nameParent][nameChild] !== "number"
    ) {
      return item;
    } else if (
      typeof item[nameParent][nameChild] === "number" &&
      item[nameParent][nameChild] !== 0
    ) {
      return item;
    } else if (
      typeof item[nameParent][nameChild] &&
      item[nameParent][nameChild] === 0
    ) {
      return {
        ...item,
        [nameParent]: {
          ...item[nameParent],
          [nameChild]: 0.1,
        },
      };
    } else {
      return {
        ...item,
        [nameParent]: {
          ...item[nameParent],
          [nameChild]: "z",
        },
      };
    }
  });
  const sorter2 = (sortBy, newSort) => (a, b) => {
    const prev = a[sortBy][newSort]?.trim()?.toLowerCase();
    const next = b[sortBy][newSort]?.trim()?.toLowerCase();
    let oldPosition = [prev, next];
    let oldIndex = oldPosition.findIndex((item) => item === prev);
    oldPosition.sort((a, b) => a.localeCompare(b, "vi"));
    let newIndex = oldPosition.findIndex((item) => item === prev);
    if (prev && next && oldIndex === newIndex) {
      return 1;
    } else {
      return -1;
    }
  };

  const fillData = newData.sort(sorter2(nameParent, nameChild));
  const afterData = fillData.map((item) => {
    if (item[nameParent][nameChild] === "z") {
      return {
        ...item,
        [nameParent]: {
          ...item[nameParent],
          [nameChild]: null,
        },
      };
    } else if (item[nameParent][nameChild] === 0.1) {
      return {
        ...item,
        [nameParent]: {
          ...item[nameParent],
          [nameChild]: 0,
        },
      };
    } else {
      return item;
    }
  });
  return afterData;
};
export const formatSecondToHour = (seconds) => {
  return new Date(seconds * 1000).toISOString().slice(11, 19);
};
export function convertToSeconds(str) {
  const [hours, minutes, seconds] = str?.split(":");
  return Number(hours) * 60 * 60 + Number(minutes) * 60 + Number(seconds);
}
export function returnArr(number) {
  let arr = [];
  for (let i = 1; i <= number; i++) {
    arr.push(i);
  }
  return arr;
}
export const cutScreen = (screen, page, data) => {
  const listData = data.filter(
    (item, index) =>
      index + 1 > screen * (page - 1) &&
      index + 1 <= screen * (page - 1) + screen
  );
  return listData;
};

export const downloadVideo = async (m3u8Url, res, name) => {
  try {
    const playlist = res.data;
    const segmentUrls = playlist
      .split("\n")
      .filter((line) => !line.startsWith("#"))
      .map((url) => new URL(url, m3u8Url).href);
    // Fetch and concatenate the video segments
    const segmentPromises = segmentUrls.map((url) => fetch(url));
    await Promise.all(segmentPromises)
      .then((responses) =>
        Promise.all(responses.map((res) => res.arrayBuffer()))
      )
      .then((buffers) => {
        const blob = new Blob(buffers, { type: "video/mp4" });
        const url = URL.createObjectURL(blob);
        // Create a download link and trigger a click event to start the download
        const a = document.createElement("a");
        a.href = url;
        a.download = `${name}.mp4`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      });
  } catch (error) { }
};

export const binarySearch = function (arr, x) {
  let start = 0,
    end = arr.length - 1;
  // Iterate while start not meets end
  while (start <= end) {
    // Find the mid index
    let mid = Math.floor((start + end) / 2);

    // If element is present at mid, return Truep
    if (arr[mid].camera_code === x) return arr[mid];
    // Else look in left or right half accordingly
    else if (arr[mid] < x) start = mid + 1;
    else end = mid - 1;
  }

  // return null;
};
export const swapArr = (arr, item1, item2) => {
  const index = arr.findIndex((it1) => it1.code === item1.code);
  const index1 = arr.findIndex((item) => item.code === item2.code);

  arr[index] = item2;
  arr[index1] = item1;

  return arr;
};
export const quickSort = (arr) => {
  if (arr.length < 2) return arr;

  // *** lấy phần tử cuối của 'arr' làm 'pivot'
  const pivotIndex = arr.length - 1;
  const pivot = arr[pivotIndex];

  const left = [];
  const right = [];

  let currentItem;
  // *** 'i < pivotIndex' => chúng ta sẽ không loop qua 'pivot' nữa
  for (let i = 0; i < pivotIndex; i++) {
    currentItem = arr[i];

    if (currentItem.total < pivot.total) {
      left.push(currentItem);
    } else {
      right.push(currentItem);
    }
  }

  return [...quickSort(left), pivot, ...quickSort(right)];
};
export const swapWarehouse = (arr, warehouse1, warehouse2) => {
  const index = arr.findIndex((it1) => it1.WAREHOUSE_CODE === warehouse1);
  const warehouseData1 = arr.filter(
    (item) => item.WAREHOUSE_CODE === warehouse1
  );
  const warehouseData2 = arr.filter(
    (item) => item.WAREHOUSE_CODE === warehouse2
  );
  const index1 = arr.findIndex((item) => item.WAREHOUSE_CODE === warehouse2);

  arr[index] = {
    ...warehouseData2[0],
    SEQ: warehouseData1[0].SEQ,
  };
  arr[index1] = {
    ...warehouseData1[0],
    SEQ: warehouseData2[0].SEQ,
  };

  return arr;
};

export const getLine = (x, y, lines) => {
  let polygon = [];
  if (lines.length === 0) {
    polygon.push({
      x1: x,
      y1: y,
      x2: x,
      y2: y,
      x1Control: x,
      y1Control: y,
      x2Control: x,
      y2Control: y,
    });
  } else {
    // Nếu đã có ít nhất một line, thêm thông tin về line mới vào cuối mảng
    if (lines.length < 3 && lines.length >= 1) {
      const lastLine = lines[lines.length - 1];
      const newLine = {
        x1: lastLine.x2,
        y1: lastLine.y2,
        x2: x,
        y2: y,
        x1Control: lastLine.x2,
        y1Control: lastLine.y2,
        x2Control: x,
        y2Control: y,
      };
      polygon.push(newLine);
    } else if (lines.length === 3) {
      const lastLine = lines[lines.length - 1];
      const firstLine = lines[0];
      const newLine = {
        x1: lastLine.x2,
        y1: lastLine.y2,
        x2: x,
        y2: y,
        x1Control: lastLine.x2,
        y1Control: lastLine.y2,
        x2Control: x,
        y2Control: y,
      };
      const endLine = {
        x1: x,
        y1: y,
        x2: firstLine.x1,
        y2: firstLine.y1,
        x1Control: x,
        y1Control: y,
        x2Control: firstLine.x1,
        y2Control: firstLine.y1,
      };
      polygon.push(newLine);
      polygon.push(endLine);
    }
  }
  return polygon;
};

export const getRoiList = (inputString) => {
  return JSON.parse(inputString);
};

export const getPolygon = (data, width, height) => {
  let polygon = {
    polygon1: [],
    polygon2: [],
    polygon3: [],
  };
  let x = width;
  let y = height;
  data.forEach((item, index) => {
    for (let i = 0; i < item.length; i++) {
      if (i === 0) {
        let firstLine = {
          x1: (item[i][0] * x) / 100,
          y1: (item[i][1] * y) / 100,
          x2: (item[i][0] * x) / 100,
          y2: (item[i][1] * y) / 100,
          x1Control: (item[i][0] * x) / 100,
          y1Control: (item[i][1] * y) / 100,
          x2Control: (item[i][0] * x) / 100,
          y2Control: (item[i][1] * y) / 100,
        };
        let newLine = {
          x1: (item[i][0] * x) / 100,
          y1: (item[i][1] * y) / 100,
          x2: (item[i + 1][0] * x) / 100,
          y2: (item[i + 1][1] * y) / 100,
          x1Control: (item[i][0] * x) / 100,
          y1Control: (item[i][1] * y) / 100,
          x2Control: (item[i + 1][0] * x) / 100,
          y2Control: (item[i + 1][1] * y) / 100,
        };
        polygon[`polygon${index + 1}`].push(firstLine);
        polygon[`polygon${index + 1}`].push(newLine);
      } else if (i === item.length - 1) {
        let newLine = {
          x1: (item[i][0] * x) / 100,
          y1: (item[i][1] * y) / 100,
          x2: (item[0][0] * x) / 100,
          y2: (item[0][1] * y) / 100,
          x1Control: (item[i][0] * x) / 100,
          y1Control: (item[i][1] * y) / 100,
          x2Control: (item[0][0] * x) / 100,
          y2Control: (item[0][1] * y) / 100,
        };
        polygon[`polygon${index + 1}`].push(newLine);
      } else {
        let newLine = {
          x1: (item[i][0] * x) / 100,
          y1: (item[i][1] * y) / 100,
          x2: (item[i + 1][0] * x) / 100,
          y2: (item[i + 1][1] * y) / 100,
          x1Control: (item[i][0] * x) / 100,
          y1Control: (item[i][1] * y) / 100,
          x2Control: (item[i + 1][0] * x) / 100,
          y2Control: (item[i + 1][1] * y) / 100,
        };
        polygon[`polygon${index + 1}`].push(newLine);
      }
    }
  });
  return polygon;
};
export const getPolygonFire = (data, width, height) => {
  let polygon = {
    polygon1: [],
    polygon2: [],
    polygon3: [],
  };
  let x = width;
  let y = height;
  data.forEach((item, index) => {
    for (let i = 0; i < item.length; i++) {
      if (i === 0) {
        let firstLine = {
          x1: (item[i][0] * x) / 1000,
          y1: (item[i][1] * y) / 1000,
          x2: (item[i][0] * x) / 1000,
          y2: (item[i][1] * y) / 1000,
          x1Control: (item[i][0] * x) / 1000,
          y1Control: (item[i][1] * y) / 1000,
          x2Control: (item[i][0] * x) / 1000,
          y2Control: (item[i][1] * y) / 1000,
        };
        let newLine = {
          x1: (item[i][0] * x) / 1000,
          y1: (item[i][1] * y) / 1000,
          x2: (item[i + 1][0] * x) / 1000,
          y2: (item[i + 1][1] * y) / 1000,
          x1Control: (item[i][0] * x) / 1000,
          y1Control: (item[i][1] * y) / 1000,
          x2Control: (item[i + 1][0] * x) / 1000,
          y2Control: (item[i + 1][1] * y) / 1000,
        };
        polygon[`polygon${index + 1}`].push(firstLine);
        polygon[`polygon${index + 1}`].push(newLine);
      } else if (i === item.length - 1) {
        let newLine = {
          x1: (item[i][0] * x) / 1000,
          y1: (item[i][1] * y) / 1000,
          x2: (item[0][0] * x) / 1000,
          y2: (item[0][1] * y) / 1000,
          x1Control: (item[i][0] * x) / 1000,
          y1Control: (item[i][1] * y) / 1000,
          x2Control: (item[0][0] * x) / 1000,
          y2Control: (item[0][1] * y) / 1000,
        };
        polygon[`polygon${index + 1}`].push(newLine);
      } else {
        let newLine = {
          x1: (item[i][0] * x) / 1000,
          y1: (item[i][1] * y) / 1000,
          x2: (item[i + 1][0] * x) / 1000,
          y2: (item[i + 1][1] * y) / 1000,
          x1Control: (item[i][0] * x) / 1000,
          y1Control: (item[i][1] * y) / 1000,
          x2Control: (item[i + 1][0] * x) / 1000,
          y2Control: (item[i + 1][1] * y) / 1000,
        };
        polygon[`polygon${index + 1}`].push(newLine);
      }
    }
  });
  return polygon;
};
export const formatDB = (date) => {
  const dateA = new Date(date);
  const year = dateA.getFullYear();
  const month =
    dateA.getMonth() + 1 < 10
      ? "0" + (dateA.getMonth() + 1)
      : dateA.getMonth() + 1;
  const day = dateA.getDate() < 10 ? "0" + dateA.getDate() : dateA.getDate();
  return day + "-" + month + "-" + year;
};

export const changeDataCam = (listCam) => {
  const companyCode = sessionStorage.getItem("company_code");
  const listStatus = [
    {
      status: 0,
      message: "Đang trực tuyến",
    },
    {
      status: 1,
      message: "Mất kết nối",
    },
    {
      status: 2,
      message: "Mất kết nối",
    },
    {
      status: 3,
      message: companyCode === "DEFAULT" ? "Sẵn sàng" : "Mất kết nối",
    },
  ];
  const dataAddMessage = listCam?.data.map((cam) => {
    const mess = listStatus.filter(
      (item) => item.status === cam?.CAMERA?.STATUS_ACTIVE
    );
    if (mess.length > 0) {
      return {
        ...cam,
        CAMERA: {
          ...cam?.CAMERA,
          MESSAGE: mess[0]?.message,
          GROUP_COUNT: cam?.GROUP_NAME?.length,
          SERVICE_COUNT: cam?.AI?.length,
        },
      };
    } else {
      return cam;
    }
  });
  return { count: listCam.count, data: dataAddMessage };
};

export const sorterAddress = (address, method) => {
  const data = address?.sort((a, b) =>
    a[`${method}`]
      .normalize("NFC")
      .localeCompare(b[`${method}`].normalize("NFC"), "vi", {
        sensitivity: "accent",
      })
  );
  return data;
};

export const generateAutoPassword = () => {
  const upperCase = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  const lowerCase = "abcdefghijklmnopqrstuvwxyz";
  const numbers = "0123456789";
  const specialChars = "!@#$%^&*()_+-=[]{}|;:,.<>?";
  const allChars = `${upperCase}${lowerCase}${numbers}${specialChars}`;

  let password = "";
  let passwordLength = Math.floor(Math.random() * 5) + 6;

  while (
    !/^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*#?&])[^\s]{6,10}$/.test(
      password
    )
  ) {
    password = "";
    for (let i = 0; i < passwordLength; i++) {
      password += allChars.charAt(Math.floor(Math.random() * allChars.length));
    }
  }

  return password;
};
// export const formatDateTo = (date)=>{
//   // console.log(date);
//   const data = date.split("-")
//   return data[2] + "-" + data[1] + "-" + data[0]
// }
export const checkTimeReGetRefresh = () => {
  const jwt = sessionStorage.getItem("refresh");
  const claims = atob(jwt.split(".")[1]);
  const jsonData = JSON.parse(claims);
  const expiration = jsonData.exp;
  const hour = 3 * 60 * 1000;
  const date = new Date(expiration * 1000);
  const now = new Date();
  let check = date - now <= hour;

  return check;
};

export const formatTimeActiveDb = (time) => {
  if (time) {
    let date = new Date(time);
    const dateCr = date.getDate();
    const monthCr = date.getMonth() + 1;
    const yearCr = date.getFullYear();
    const houtCr = date.getHours();
    const minuteCr = date.getMinutes();
    let timeFm = `${yearCr}/${monthCr < 10 ? "0" + monthCr : monthCr}/${dateCr < 10 ? "0" + dateCr : dateCr
      } ${houtCr < 10 ? "0" + houtCr : houtCr}:${minuteCr < 10 ? "0" + minuteCr : minuteCr
      }:00`;
    return timeFm;
  }
};
export function getRandomArbitrary(min, max) {
  return Math.random() * (max - min) + min;
}
export const choseCameraPlayBack = (listCode, payloadData) => {
  let indexItem = listCode.findIndex(
    (item) => item?.warehouseCode === payloadData?.warehouseCode
  );
  if (indexItem >= 0) {
    let itemWare = listCode[indexItem];
    if (payloadData.type === "listCam") {
      if (payloadData.add === true) {
        listCode[indexItem] = {
          ...payloadData,
          data: [...payloadData.data, ...itemWare.data],
        };
        return [...listCode];
      } else {
        let notRemove = itemWare.data.filter((item) => {
          let index = payloadData.data.findIndex((it) => it.code === item.code);
          return index === -1;
        });
        if (notRemove.length > 0) {
          listCode[indexItem] = {
            ...payloadData,
            data: [...notRemove],
          };
          return [...listCode];
        } else {
          listCode.splice(indexItem, 1);
          return [...listCode];
        }
      }
    } else {
      // type === cam;
      let itemCam = listCode[indexItem];
      if (payloadData.add) {
        let newItem = {
          ...itemCam,
          type: payloadData.type,
          data: [...payloadData.data, ...itemCam.data],
        };
        listCode[indexItem] = newItem;
        const listNewposition = array_move(listCode, indexItem, 0);
        return [...listNewposition];
      } else {
        let listData = [...itemCam.data];
        let camInPayLoad = payloadData.data[0];
        let newListCam = listData.filter(
          (item) => item.code !== camInPayLoad.code
        );
        let newItem = {
          ...itemCam,
          type: payloadData.type,
          data: [...newListCam],
        };
        listCode[indexItem] = newItem;
        return [...listCode];
      }
    }
  } else {
    return [payloadData, ...listCode];
  }
};

export function searchingCameraRoleFE(
  page,
  size,
  listAllCam,
  listUserCam,
  status
) {
  let dataBase = [...listAllCam];
  let startPage = ((page ? page : 0) - 1) * (size ? size : 1000);
  let resultData = [];
  let total = 1;

  const pagingFc = (listData) => {
    let listCam = [];
    if (size) {
      listCam = [...listData.slice(startPage, startPage + size)];
    } else {
      listCam = [...listData.slice()];
    }
    return listCam;
  };

  if (listUserCam && listUserCam.length > 0) {
    let dataSetUp = [...listUserCam];
    if (status === "all") {
      let listCam = pagingFc(dataBase);
      total = dataBase.length ? dataBase.length : 1;
      resultData = [...listCam];
    } else if (status === 1) {
      let listCam = pagingFc(dataSetUp);
      total = dataSetUp.length ? dataSetUp.length : 1;
      resultData = [...listCam];
    } else if (status === 0) {
      let listCamNotRole = dataBase.filter((cam) => {
        let indexItem = dataSetUp.findIndex((it) => it.CODE === cam.CODE);
        return indexItem === -1;
      });
      let listCam = pagingFc(listCamNotRole);
      resultData = [...listCam];
      total = listCamNotRole.length ? listCamNotRole.length : 1;
    }
    return {
      total: total,
      data: [...resultData],
    };
  }
}

export const formatPriceVND = (price) => {
  var x = Number(price);
  if (x.toString() !== "NaN") {
    x = x.toLocaleString("it-IT", { style: "currency", currency: "VND" });
    return x;
  } else {
    return "0 VND";
  }
};
export const returnDay = (month) => {
  const data = [1, 3, 5, 7, 8, 10, 12];
  const m = month > 12 ? month - 12 : month;
  const check = data.some((item) => item === month % 12);
  if (check) {
    return 31;
  } else {
    if (month % 12 === 2) {
      return 28;
    } else {
      return 30;
    }
  }
};
export const convertDay = (day) => {
  // // console.log(day);
  if (day % 12 > 0 && day % 12 < 10) {
    return `0${day % 12}`;
  } else {
    if (day <= 12) {
      return day;
    } else {
      return day % 12;
    }
  }
};
export const changeYear = (year, month, total) => {
  if (total % 12 === 0) {
    const du = Math.floor(total / 12);
    return year + du - 1;
  } else {
    const du = Math.floor(total / 12);
    return year + du;
  }
};
export const convertTimePM = (date = "10:00") => {
  const split = date.split(":")[0];
  if (Number(split) > 12) {
    return Number(split) - 12 >= 10
      ? `${Number(split) - 12}:${Number(date.split(":")[1]) > 10 ? Number(date.split(":")[1]) : `0${Number(date.split(":")[1])}`} PM`
      : `0${Number(split) - 12}:${Number(date.split(":")[1]) > 10 ? Number(date.split(":")[1]) : `0${Number(date.split(":")[1])}`} PM`;
  } else {
    return `${date} AM`;
  }
};
export const changePathStream = (stream = [], newPath) => {
  let listPath = [];
  stream.forEach((item) => {
    listPath.push(item);
  });
  let index = stream.findIndex(
    (item) => item.code === JSON.parse(newPath).camera_id
  );
  listPath[index] = {
    ...listPath[index],
    url: `${process.env.REACT_APP_BASE_URL}livestream${JSON.parse(newPath)?.stream_path
      }`,
    status: JSON.parse(newPath)?.stream_path === "no-path" ? "Weak" : "On",
    url2: `${process.env.REACT_APP_BASE_URL}livestream${JSON.parse(newPath)?.stream_path
      }`,
  };
  return listPath;
};

export const limitChangePoint = (point, max) => {
  if (point > 0) {
    return 0;
  } else {
    if (point < -max) {
      return -max;
    } else {
      return point;
    }
  }
};
export const convertArray = (arr = []) => {
  let list = [];
  arr.forEach((item) => {
    item.data.forEach((it) => list.push(it));
  });
  return list;
};
export const convertStatus = (status) => {
  if (status === "all") {
    return "Tất cả";
  } else if (status === "On") {
    return "Đang bật";
  } else if (status === "Off") {
    return "Đang tắt";
  }
};
export const checkTime = (start, end) => {
  let convert_start = new Date().setHours(
    start?.split(":")[0],
    start?.split(":")[0],
    0
  );
  let convert_end = new Date().setHours(
    end?.split(":")[0],
    end?.split(":")[0],
    0
  );
  let convert_time = new Date;
  // console.log(convert_time.getHours());
  // console.log(convert_time);
  let time = new Date().setHours(
    convert_time.getHours(),
    convert_time.getMinutes(),
    0
  );
  // console.log(convert_start);
  if (Number(convert_start) <= Number(time) && Number(time) <= Number(convert_end)) {
    return true;
  }
  return false;
};
export const checkTimeHouse = (start, end) => {
  // console.log(start, end);
  // if (Number(start.split(":")[0]) > Number(end.split(":")[0])) {
  //   return true
  // }
  // else if (Number(start.split(":")[0]) === Number(end.split(":")[0]) && Number(start.split(":")[1]) > Number(end.split(":")[1])) {
  //   return true
  // }
  return false
};
export const convertMinDate = (day) => {
  if (day && typeof day === "number") {
    if (day > 30 && day < 365) {
      return {
        unit: "thang",
        count: day / 30,
      };
    } else if (day > 365) {
      return {
        unit: "nam",
        count: day / 365,
      };
    } else {
      return {
        unit: "ngay",
        count: day,
      };
    }
  } else {
    return {
      unit: "",
      count: 0,
    };
  }
};

export const downloadImage = (blob, fileName) => {
  const fakeLink = window.document.createElement("a");
  fakeLink.style = "display:none;";
  fakeLink.download = fileName;
  fakeLink.href = blob;
  document.body.appendChild(fakeLink);
  fakeLink.click();
  document.body.removeChild(fakeLink);
  fakeLink.remove();
};

export const countDays = (unit, count) => {
  if (unit === 'thang') {
    return count * 30
  } else if (unit === 'nam') {
    return count * 365
  } else {
    return count
  }
}

export const formatMMDDYY = (date) => {
  const dateA = new Date(date);
  const year = dateA.getFullYear();
  const month =
    dateA.getMonth() + 1 < 10
      ? "0" + (dateA.getMonth() + 1)
      : dateA.getMonth() + 1;
  const day = dateA.getDate() < 10 ? "0" + dateA.getDate() : dateA.getDate();
  return month + "/" + day + "/" + year;
};

export const downloadVideoPlayBack = async (response, name) => {
  try {


    // Tạo một đường dẫn URL từ dữ liệu Blob và tải xuống tệp tin
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `${name}.mp4`);
    document.body.appendChild(link);
    link.click();

    // Giải phóng nguồn tài nguyên
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Error downloading video:', error);
  }
};

export const getTimeFormArray = (timeArr) => {
  const day = timeArr[2] < 10 ? "0" + timeArr[2] : timeArr[2];
  const month = timeArr[1] < 10 ? "0" + timeArr[1] : timeArr[1];
  const year = timeArr[0];
  return `${day}/${month}/${year}`
}

export const getTimeFormArrayToHour = (timeArr) => {
  const day = timeArr[2] < 10 ? "0" + timeArr[2] : timeArr[2];
  const month = timeArr[1] < 10 ? "0" + timeArr[1] : timeArr[1];
  const year = timeArr[0];
  const hour = timeArr[3] < 10 ? "0" + timeArr[3] : timeArr[3];
  const minute = timeArr[4] < 10 ? "0" + timeArr[4] : timeArr[4];
  return `${day}/${month}/${year} - ${hour}:${minute}`
}

export function formatCash(str) {
  const arrStr = str.split('.');
  if (str) {
    if (arrStr.length <= 1) {
      return str.split('').reverse().reduce((prev, next, index) => {
        return ((index % 3) ? next : (next + ',')) + prev
      })
    } else {
      return `${arrStr[0].split('').reverse().reduce((prev, next, index) => {
        return ((index % 3) ? next : (next + ',')) + prev
      })}.${arrStr[1]}`
    }
  }
  return str;
}

export const getTimeApplyFromArr = (time) => {
  const hour = time[0] < 10 ? "0" + time[0] : time[0];
  const minute = time[1] < 10 ? "0" + time[1] : time[1];
  return `${hour}:${minute}`
}

export const SCECHULE = [
  "TIME_START_ACTIVE",
  "TIME_END_ACTIVE",
  "IS_ZOOM",
  "IS_VOICE",
  "DELETE_IF_OFF",
  "TIME_KEEPING_EVENT_DEFAULT",
  "TIME_ALERT_EVENT",
  "CARE_CLASSES"
]

export const checkRoleSupAdmin = () => {
  return localStorage?.getItem("role")?.split(",")?.some(r => r === 'A')
}

export const LANGUAGES = [
  { label: "Tiếng Việt", value: "vi", flag: <VietNamFlag />, sort: "VI" },
  { label: "English", value: "en", flag: <UnitedKingdomFlag />, sort: "EN" },
];


export const listAiTranslate = [
  {
    ai_service_code: "20230222000000000006",
    ai_name: "Nhận dạng biển số xe",
    name_tr: t("services.licensePlate")
  },
  {
    ai_service_code: "20230222000000000005",
    ai_name: "Phát hiện camera di chuyển",
    name_tr: t("services.cameraMoving")
  },
  {
    ai_service_code: "20230222000000000007",
    ai_name: "Cảnh báo cháy",
    name_tr: t("services.fireWarning"),
  },
  {
    ai_service_code: "20230222000000000002",
    name_tr: t("services.faceRecognition"),
    ai_name: "Nhận dạng khuôn mặt"
  },
  {
    ai_service_code: "20230222000000000001",
    name_tr: t("services.motionDetection"),
    ai_name: "Phát hiện chuyển động"
  },
  {
    ai_service_code: "20230222000000000004",
    name_tr: t("services.detectCommonObjects"),
    ai_name: "Phát hiện xâm nhập"
  },
  {
    ai_service_code: null,
    name_tr: t("services.cameraRestartNotification"),
    ai_name: "Thông báo khởi động lại camera"
  },
  {
    ai_service_code: null,
    name_tr: t("services.notificationOfCameraLosingConnection"),
    ai_name: "Thông báo camera mất kết nối"
  },
  {
    ai_service_code: null,
    name_tr: t("services.notificationOfWarehouseConnectionLoss"),
    ai_name: "Thông báo kho mất kết nối"
  },
  {
    ai_service_code: null,
    name_tr: t("services.systemErrorMessage"),
    ai_name: "Thông báo lỗi hệ thống"
  },
  {
    ai_service_code: null,
    name_tr: t("services.eventTracing"),
    ai_name: "Truy vết sự kiện"
  },
  {
    ai_service_code: null,
    name_tr: t("services.Warehouse_lost_connection"),
    ai_name: "Kho mất kết nối"
  },
  {
    ai_service_code: null,
    name_tr: t("services.Camera_reboot"),
    ai_name: "Camera khởi động lại"
  },
  {
    ai_service_code: null,
    name_tr: t("services.Camera_lost_connection"),
    ai_name: "Camera mất kết nối"
  },
  {
    ai_service_code: null,
    name_tr: t("services.System_error"),
    ai_name: "Lỗi hệ thống"
  },
]
export const listParamTranslate = [
  {
    param_name: "Điều kiện sáng",
    name_tr: t('param.Lighting_conditions')
  },
  {
    param_name: "Bật âm thanh",
    name_tr: t('setting.Turn_on_sound')
  },
  {
    param_name: "Độ nhạy",
    name_tr: t('param.Sensitivity')
  },
  {
    param_name: "Kích thước đối tượng",
    name_tr: t('param.Object_size')
  },
  {
    param_name: "Thời gian không có sự kiện",
    name_tr: t('param.Time_without_events')
  },
  {
    param_name: "Thời gian sự kiện tối thiểu",
    name_tr: t('param.Minimum_event_time')
  },
  {
    param_name: "Phương tiện di chuyển",
    name_tr: t('param.Means_of_transport')
  },
  {
    param_name: "Yêu cầu độ chính xác",
    name_tr: t('param.Accuracy_required')
  },
  {
    param_name: "Mức độ bỏ qua khung hình",
    name_tr: t('param.Frame_skipping_level')
  },
  {
    param_name: "Độ nhạy cảm phát hiện khuôn mặt",
    name_tr: t('param.Face_detection_sensitivity')
  },
  {
    param_name: "Ngưỡng đối sánh khuôn mặt",
    name_tr: t('param.Face_matching_threshold')
  },
  {
    param_name: "Độ nghiêng trái phải",
    name_tr: t('param.Left_and_right_tilt')
  },
  {
    param_name: "Độ cúi, ngửa đầu",
    name_tr: t('param.Head_tilt')
  },
  {
    param_name: "Thời gian xác nhận lại khuôn mặt",
    name_tr: t('param.Face_Re_verification_Time')
  },
  {
    param_name: "Thời gian sống của đối tượng",
    name_tr: t('param.Object_lifetime')
  },
  {
    param_name: "Nhiêt độ báo động",
    name_tr: t('param.Alarm_temperature')
  },
]

export const listParamLevelTranslate = [
  {
    param_name: "Cao",
    name_tr: t('param.High')
  },
  {
    param_name: "Thấp",
    name_tr: t('param.Low')
  },
  {
    param_name: "Trung bình",
    name_tr: t('param.Medium')
  },
  {
    param_name: "Lớn",
    name_tr: t('param.Big')
  },
  {
    param_name: "Nhỏ",
    name_tr: t('param.Small')
  },
  {
    param_name: "Từ trên xuống",
    name_tr: t('param.Top_to_bottom')
  },
  {
    param_name: "Từ dưới lên",
    name_tr: t('param.Bottom_up')
  },
  {
    param_name: "Nghiêm trọng",
    name_tr: t('param.Serious')
  },
  {
    param_name: "Thông tin",
    name_tr: t('param.Information')
  },
  {
    param_name: "Không bỏ qua",
    name_tr: t('param.Do_not_miss_out')
  },
  {
    param_name: "Cao nhất",
    name_tr: t('param.Highest')
  },
]

// downloadVideoPlayBack() 
export const formatTimeCheckNotification = (date) => {
  const dateA = new Date(date);
  const year = dateA.getFullYear();
  const month =
    dateA.getMonth() + 1 < 10
      ? "0" + (dateA.getMonth() + 1)
      : dateA.getMonth() + 1;
  const day = dateA.getDate() < 10 ? "0" + dateA.getDate() : dateA.getDate();
  const hour = dateA.getHours() < 10 ? "0" + dateA.getHours() : dateA.getHours();
  const minute =
    dateA.getMinutes() < 10 ? "0" + dateA.getMinutes() : dateA.getMinutes();
  const second =
    dateA.getSeconds() < 10 ? "0" + dateA.getSeconds() : dateA.getSeconds();
  return year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second;
};

export const convertStringToDate = (timeString) => {
  // Tách chuỗi thời gian thành ngày và giờ
  let parts = timeString.split(' ');
  let dateParts = parts[0].split('-');
  let timeParts = parts[1].split(':');

  // Tạo đối tượng Date
  let convertedTime = new Date(
    dateParts[2],  // Năm
    dateParts[1] - 1,  // Tháng (JavaScript sử dụng chỉ số tháng từ 0-11)
    dateParts[0],  // Ngày
    timeParts[0],  // Giờ
    timeParts[1]   // Phút
  );

  // Trả về đối tượng Date
  return convertedTime;
}
export function isDifferenceTwoHours(date1, date2) {
  // Tính chênh lệch thời gian giữa hai thời điểm (miliseconds)
  let diffInMilliseconds = Math.abs(date2 - date1);  // Dùng abs để lấy giá trị tuyệt đối

  // Chuyển đổi chênh lệch thời gian từ miliseconds sang giờ
  let diffInHours = diffInMilliseconds / (1000 * 60 * 60);  // 1000 ms * 60 giây * 60 phút

  // Kiểm tra nếu chênh lệch là 2 giờ hoặc hơn
  return diffInHours >= 2;
}

// Lấy danh sách các key trên url param. input key là một mảng để trong trường hợp nhận vào nhiều key.
export function getStatusParam(keys) {
  let result = {};
  const url = new URL(window.location.href);
  const params = new URLSearchParams(url.search);
  for (let key of keys) {
    const state = params.get(key);
    result[key] = state;
  }
  return result;
}


export const isPointOnLine = (px, py, line) => {
  const { x1, y1, x2, y2 } = line;
  const tolerance = 5;

  const d1 = Math.sqrt((px - x1) ** 2 + (py - y1) ** 2);
  const d2 = Math.sqrt((px - x2) ** 2 + (py - y2) ** 2);
  const lineLength = Math.sqrt((x2 - x1) ** 2 + (y2 - y1) ** 2);

  return Math.abs(d1 + d2 - lineLength) < tolerance;
};

export const isNearPoint = (px, py, point) => {
  const tolerance = 10;
  return (
    Math.abs(px - point.x) < tolerance && Math.abs(py - point.y) < tolerance
  );
};

export const getHours = (time) => {
  const date = new Date(time);
  const hour = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
  const minute =
    date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
  const second =
    date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
  return hour + ":" + minute + ":" + second;
}


export function playManySounds(soundUrls) {
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const soundPaths = soundUrls ? [...soundUrls] : [];

  let currentIndex = 0;
  const audio = new Audio();
  let isPlaying = false;
  let countTry = 0;

  function playNextSound() {
    if (currentIndex < soundPaths.length && isPlaying) {
      audio.src = baseUrl + soundPaths[currentIndex];
      audio.play().then(() => {
        currentIndex++;
      }).catch(error => {
        console.error("Error playing audio:", error);
        currentIndex++;
        if (countTry < 3) {
          countTry++;
          playNextSound();
        }
      });
    }
  }

  audio.addEventListener('ended', playNextSound);

  if (!isPlaying) {
    isPlaying = true;
    playNextSound();
  }
}